import React from "react";
import moment from "moment";
import Cookie from "js-cookie";
import axios from "@/utils/myAxios";
import {
    BrowserRouter as Router,
    Route,
    Redirect,
    Switch,
    Link,
} from "react-router-dom";
import MenuRouter from "@/pages/commom/MenuRouter";
import Header from "@/pages/commom/Header";
import { Modal, Tag, Row } from "antd";
import {
    superUnionMenu,
    superUnionVipMenu,
    superUnionAdminMenu,
    superUnionAdminServiceMenu,
    superUnionAdminFinanceMenu,
    superUnionAdminManagementMenu,
    unionMenu,
    unionVipMenu,
    unionAdminMenu,
    unionAdminServiceMenu,
    directUnionMenu,
    directUnionVipMenu,
    directUnionAdminMenu,
    directUnionAdminServiceMenu,
    kpokerUnionMenu,
    kpokerUnionVipMenu,
    kpokerUnionAdminMenu,
    kpokerUnionAdminServiceMenu,
} from "@/pages/commom/MenuList";

export default class Main extends React.Component {
    // 渲染路由
    renderRoute = (route, langInfo) => {
        return route.redirect ? (
            <Redirect
                to={route.redirect}
                from={route.path}
                exact={route.exact}
                strict={route.strict}
                key={String(Math.random())}
            />
        ) : (
            <Route
                key={String(Math.random())}
                path={route.path}
                title={route.title}
                exact={route.exact}
                strict={route.strict}
                render={(props) => (
                    <route.component title={route.title} {...props} {...langInfo} />
                )}
            />
        );
    }

    render () {
        let routes = [];
        let identityType = Cookie.get("identityType");
        let allowCreate = Cookie.get("allowCreate");
        let isKpoker = Cookie.get("isKpoker");
        let canSetLocalCoinRate = Cookie.get("canSetLocalCoinRate");
        let showTable = Cookie.get("showTable");
        let showMtt = Cookie.get("showMtt");

        // 匹配路由
        let identityTypeName, unionType, unionTypeName;
        switch (identityType) {
            // 超盟主
            case "super_union":
                identityTypeName = this.props.language["superUnionMaster"];
                unionType = "super_union";
                unionTypeName = this.props.language["superUnionTitle"];
                routes = superUnionMenu
                break;
            // 超盟vip
            case "super_union_vip":
                identityTypeName = this.props.language["superUnionVip"];
                unionType = "super_union";
                unionTypeName = this.props.language["superUnionTitle"];
                routes = superUnionVipMenu
                break;
            // 超盟管理员
            case "super_union_admin":
                identityTypeName = this.props.language["superUnionAdmin"];
                unionType = "super_union";
                unionTypeName = this.props.language["superUnionTitle"];
                routes = superUnionAdminMenu
                break;
            // 超盟客服
            case "super_union_admin_service":
                identityTypeName = this.props.language["superUnionAdminService"];
                unionType = "super_union";
                unionTypeName = this.props.language["superUnionTitle"];
                routes = superUnionAdminServiceMenu
                break;
            // 超盟商务
            case "super_union_admin_finance":
                identityTypeName = this.props.language["superUnionAdminFinance"];
                unionType = "super_union";
                unionTypeName = this.props.language["superUnionTitle"];
                routes = superUnionAdminFinanceMenu
                break;
            // 超盟管理层
            case "super_union_admin_management":
                identityTypeName = this.props.language["superUnionAdminManagement"];
                unionType = "super_union";
                unionTypeName = this.props.language["superUnionTitle"];
                routes = superUnionAdminManagementMenu
                break;
            // 联盟主
            case "union":
                identityTypeName = this.props.language["unionMaster"];
                unionType = "union";
                unionTypeName = this.props.language["unionTitle"];
                routes = unionMenu
                break;
            // 联盟vip
            case "union_vip":
                identityTypeName = this.props.language["unionVip"];
                unionType = "union";
                unionTypeName = this.props.language["unionTitle"];
                routes = unionVipMenu
                break;
            // 联盟管理员
            case "union_admin":
                identityTypeName = this.props.language["unionAdmin"];
                unionType = "union";
                unionTypeName = this.props.language["unionTitle"];
                routes = unionAdminMenu
                break;
            // 联盟客服
            case "union_admin_service":
                identityTypeName = this.props.language["unionAdminService"];
                unionType = "union";
                unionTypeName = this.props.language["unionTitle"];
                routes = unionAdminServiceMenu
                break;
            // 直营联盟主
            case "direct_union":
                identityTypeName = this.props.language["directUnionMaster"];
                unionType = "direct_union";
                unionTypeName = this.props.language["directUnionTitle"];
                routes = directUnionMenu
                break;
            // 直营联盟vip
            case "direct_union_vip":
                identityTypeName = this.props.language["directUnionVip"];
                unionType = "direct_union";
                unionTypeName = this.props.language["directUnionTitle"];
                routes = directUnionVipMenu
                break;
            // 直营联盟管理员
            case "direct_union_admin":
                identityTypeName = this.props.language["directUnionAdmin"];
                unionType = "direct_union";
                unionTypeName = this.props.language["directUnionTitle"];
                routes = directUnionAdminMenu
                break;
            // 直营联盟客服
            case "direct_union_admin_service":
                identityTypeName = this.props.language["directUnionAdminService"];
                unionType = "direct_union";
                unionTypeName = this.props.language["directUnionTitle"];
                routes = directUnionAdminServiceMenu
                break;
            // kpoker联盟主
            case "kpoker_union":
                identityTypeName = this.props.language["kpokerUnionMaster"];
                unionType = "kpoker_union";
                unionTypeName = this.props.language["kpokerUnionTitle"];
                routes = kpokerUnionMenu
                break;
            // kpoker联盟vip
            case "kpoker_union_vip":
                identityTypeName = this.props.language["kpokerUnionVip"];
                unionType = "kpoker_union";
                unionTypeName = this.props.language["kpokerUnionTitle"];
                routes = kpokerUnionVipMenu
                break;
            // kpoker联盟管理员
            case "kpoker_union_admin":
                identityTypeName = this.props.language["kpokerUnionAdmin"];
                unionType = "kpoker_union";
                unionTypeName = this.props.language["kpokerUnionTitle"];
                routes = kpokerUnionAdminMenu
                break;
            // kpoker联盟客服
            case "kpoker_union_admin_service":
                identityTypeName = this.props.language["kpokerUnionAdminService"];
                unionType = "kpoker_union";
                unionTypeName = this.props.language["kpokerUnionTitle"];
                routes = kpokerUnionAdminServiceMenu
                break;
        }

        // 权限限制
        routes = allowCreate === "true"
            ? routes
            : routes.filter(
                (item, index) => item.path !== '/table_manage' && item.path !== '/props_consume_record'
            );
        routes = isKpoker === "true"
            ? routes
            : routes.filter(
                (item, index) => item.path !== '/kpoker_union_bet_record' && item.path !== '/kpoker_union_integral_record'
            );
        routes = canSetLocalCoinRate === "true"
            ? routes
            : routes.filter(
                (item, index) => item.path !== '/local_currency_ratio'
            );
        routes = showTable === "true"
            ? routes
            : routes.filter(
                (item, index) => item.path !== '/table_manage'
            );
        routes = showMtt === "true"
            ? routes
            : routes.filter(
                (item, index) => item.path !== '/mtt_manage'
            );

        Cookie.set("identityTypeName", identityTypeName, { expires: 0.1 }); // 账号权限类型名称
        Cookie.set("unionType", unionType, { expires: 0.1 }); // 联盟类型
        Cookie.set("unionTypeName", unionTypeName, { expires: 0.1 }); // 联盟类型名称

        return (
            <Router>
                <div className="main">
                    {/* 左侧菜单 */}
                    <div className="main-menu">
                        <MenuRouter {...this.props} menus={routes} title={unionTypeName} />
                    </div>

                    {/* 右侧页头 */}
                    <div className="main-header">
                        < Header {...this.props} />
                    </div>

                    {/* 右侧内容 */}
                    <div className="main-content">
                        <Switch>
                            {routes.reduce((total, item) => {
                                const routeList = item.children
                                    ? item.children.map((item2) => this.renderRoute(item2, this.props))
                                    : [this.renderRoute(item, this.props)];
                                return [...total, ...routeList];
                            }, [])}
                        </Switch>
                    </div>
                </div>
            </Router>
        );
    }
}
